import { TClientFileTypeId } from './ClientFileType';

export type TClientFileId = number;

export enum FileType {
  CSV = 'csv',
  DOC = 'doc',
  DOCX = 'docx',
  PDF = 'pdf',
  TXT = 'txt',
  XLS = 'xls',
  XLSX = 'xlsx',
}

interface User {
  id: number;
  email: string;
  name: string;
  role_id: number;
  is_internal: boolean;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  phone: string | null;
  new_unverified_email: string | null;
  last_login_at: string;
}

interface ClientFileState {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
}

export interface ClientFile {
  id: TClientFileId;
  client_id: number;
  name: string;
  type: FileType;
  client_file_type_id: TClientFileTypeId;
  client_file_state_id: number;
  user_id: number;
  comments: string | null;
  uploaded_at: string;
  client_file_type: {
    id: TClientFileTypeId;
    name: string;
    created_at: string;
    updated_at: string;
  };
  client_file_state: ClientFileState;
  user: User;
  client?: {
    id: number;
    name: string;
  };
}
